export const CABINET_EMAIL = 'contact@pauline-ngoma-mabala.fr'

export const CABINET_EMAIL_HREF = `mailto:${CABINET_EMAIL}`

export const CABINET_PHONE = '+33 4 13 41 47 30'

export const CABINET_PHONE_HREF = 'tel:+33413414730'

export const CABINET_ADDRESS_LINES = [
  '4 avenue du 8 mai',
  'Immeuble Europe Résidence',
  'Bureau 103',
  '13090 Aix-en-Provence',
]
